import React from 'react';
import './PrivacyPolicy.css';
import Navbar from '../home/Navbar';
import Footer from '../footer'

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <Navbar />
      <div className="privacy-container">
        <header className="privacy-header">
          <div className="header-content">
            <h1>Privacy Policy</h1>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>
        </header>

        <div className="privacy-content">
          {/* Section 1: Introduction */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">1</div>
              <h2>Introduction</h2>
            </div>
            <div className="section-content">
              <p>
                Kode Blue Technologies ("KBT," "we," "our," or "us") is committed to protecting your privacy.
                We provide emergency medical response services by connecting hospitals, ambulances, and patients
                through our wearable devices, mobile application, and related services (collectively, the "Services").
              </p>
              <p>
                This Privacy Policy outlines how we collect, use, disclose, and protect your personal information
                when you use our services. It complies with the Information Technology Act, 2000, and other applicable
                Indian data protection laws. This policy applies to all users of our Services within India and, where
                applicable, to international users. By using our Services, you agree to the terms of this Privacy Policy.
              </p>
              <div className="notice-box">
                <p>
                  <strong>By using our services or providing us with your information, you acknowledge that you have read,
                    understood, and agreed to the practices outlined in this Privacy Policy, and consent to the collection,
                    use, and sharing of your information as described herein.</strong> We may modify this Privacy Policy at any time,
                  and if you do not agree with the terms, you should refrain from using our services or providing your information.
                  If you use the services on behalf of another individual or entity, you confirm that you are authorized to
                  accept this Privacy Policy and consent on their behalf.
                </p>
              </div>
            </div>
          </section>

          {/* Section 2: Information We Collect */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">2</div>
              <h2>Information We Collect</h2>
            </div>
            <div className="section-content">
              <p>We collect various types of information to provide and improve our Services:</p>

              <div className="info-grid">
                <div className="info-card">
                  <div className="info-icon">A</div>
                  <h3>Personal Information</h3>
                  <p>Name, gender, email address, phone number, emergency contact details, and insurance data.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">B</div>
                  <h3>Health Information</h3>
                  <p>Heart rate, blood pressure, and location data during emergency situations collected through wearable devices.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">C</div>
                  <h3>Location Data</h3>
                  <p>Real-time location during emergencies via GPS to facilitate ambulance dispatch and routing.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">D</div>
                  <h3>Service Usage Data</h3>
                  <p>Ambulance request details, hospital preferences, and interaction with our mobile app.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">E</div>
                  <h3>Device Information</h3>
                  <p>Device type, operating system, and unique device identifiers used to access our Services.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">F</div>
                  <h3>Ambulance Usage Data</h3>
                  <p>Frequency of ambulance requests, pick-up/drop-off locations, response times, and emergency types.</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">G</div>
                  <h3>Hospital Preference Data</h3>
                  <p>Preferred hospitals, previous visits, and specific requirements for hospital care.</p>
                </div>

                <div className='info'>
                  
                </div>
              </div>
            </div>
          </section>

          {/* Section 3: How We Use Your Information */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">3</div>
              <h2>How We Use Your Information</h2>
            </div>
            <div className="section-content">
              <p>We use the collected information for various purposes:</p>

              <div className="usage-grid">
                <div className="usage-card">
                  <h3>Emergency Response</h3>
                  <p>To dispatch ambulances to your location, share critical health information with emergency responders and hospitals, and coordinate your care.</p>
                </div>

                <div className="usage-card">
                  <h3>Service Provision</h3>
                  <p>To operate, maintain, and improve our Services, including optimizing ambulance routes and hospital selection.</p>
                </div>

                <div className="usage-card">
                  <h3>Communication</h3>
                  <p>To send you notifications about your emergency requests, Service updates, and support-related messages.</p>
                </div>

                <div className="usage-card">
                  <h3>Quality Improvement</h3>
                  <p>To analyze usage patterns and service performance to enhance our emergency response times.</p>
                </div>

                <div className="usage-card">
                  <h3>Research and Development</h3>
                  <p>Using anonymized data to improve our algorithms for faster emergency response and better coordination.</p>
                </div>

                <div className="usage-card">
                  <h3>Personalization</h3>
                  <p>To tailor our services to your preferences, such as prioritizing your preferred hospitals during emergencies.</p>
                </div>

                <div className="usage-card">
                  <h3>Trend Analysis</h3>
                  <p>To identify patterns in emergency service usage for better resource allocation and future predictions.</p>
                </div>

                <div className="usage-card">
                  <h3>Legal Compliance</h3>
                  <p>To comply with legal obligations and protect the rights, property, or safety of KBT, our users, or others.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 4: Data Sharing and Disclosure */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">4</div>
              <h2>Data Sharing and Disclosure</h2>
            </div>
            <div className="section-content">
              <div className="subsection">
                <h3>4.1. We do not share your personal information with third parties except in the following circumstances:</h3>

                <div className="disclosure-grid">
                  <div className="disclosure-card">
                    <h4>Emergency Services</h4>
                    <p>We share necessary health and location data with ambulance services and hospitals to facilitate emergency response and treatment.</p>
                  </div>

                  <div className="disclosure-card">
                    <h4>Healthcare Providers</h4>
                    <p>Your health information and service usage data may be shared with your chosen or nearest available hospital to prepare for your arrival and continue care.</p>
                  </div>

                  <div className="disclosure-card">
                    <h4>Government Agencies</h4>
                    <p>We may share anonymized data with government health agencies for public health purposes or as required by law.</p>
                  </div>

                  <div className="disclosure-card">
                    <h4>Service Providers</h4>
                    <p>We may share data with third-party service providers who help us operate our Services, such as cloud storage providers or analytics services.</p>
                  </div>

                  <div className="disclosure-card">
                    <h4>With Your Consent</h4>
                    <p>We may share your information with other third parties when you have provided explicit consent.</p>
                  </div>
                </div>
              </div>

              <div className="subsection">
                <h3>4.2. Additional Purposes for Information Utilization</h3>
                <p>This sharing is limited to what is necessary for service provision and is subject to strict security measures:</p>

                <div className="purpose-grid">
                  <div className="purpose-item">Identifying the End-User</div>
                  <div className="purpose-item">Publishing relevant information</div>
                  <div className="purpose-item">Introducing new products or services</div>
                  <div className="purpose-item">Gathering feedback</div>
                  <div className="purpose-item">Enhancing design and functionality</div>
                  <div className="purpose-item">Commercial use of anonymized data</div>
                  <div className="purpose-item">Payment processing</div>
                </div>
              </div>

              <div className="subsection">
                <h3>4.3. Sharing of Ambulance Usage and Hospital Preference Data:</h3>

                <div className="sharing-grid">
                  <div className="sharing-card">
                    <h4>With Ambulance Services</h4>
                    <p>We may share relevant usage data with our partner ambulance services to facilitate faster response times and better service.</p>
                  </div>

                  <div className="sharing-card">
                    <h4>With Hospitals</h4>
                    <p>Your hospital preference data may be shared with medical facilities to help them prepare for your arrival in emergency situations.</p>
                  </div>

                  <div className="sharing-card">
                    <h4>For Research</h4>
                    <p>Anonymized ambulance usage and hospital preference data may be used for research purposes to improve emergency medical services overall.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 5: Confidentiality & Data Security */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">5</div>
              <h2>Confidentiality & Data Security</h2>
            </div>
            <div className="section-content">
              <p>
                We implement robust security measures to protect your information from unauthorized access,
                disclosure, alteration, or destruction. This includes encryption, access control, and regular security audits.
              </p>

              <div className="security-grid">
                <div className="security-card">
                  <h3>Data Management and Security</h3>
                  <p>All sensitive data is encrypted during transmission and storage using industry-standard encryption protocols.</p>
                </div>

                <div className="security-card">
                  <h3>Password Protection</h3>
                  <p>Kode Blue Technologies does not have access to your password. You are responsible for safeguarding your credentials.</p>
                </div>

                <div className="security-card">
                  <h3>Access Control</h3>
                  <p>Strict access controls ensure only authorized personnel can access user data on a need-to-know basis.</p>
                </div>

                <div className="security-card">
                  <h3>Healthcare Support</h3>
                  <p>We assist healthcare professionals in organizing and managing information while maintaining confidentiality.</p>
                </div>

                <div className="security-card">
                  <h3>Patient Access</h3>
                  <p>Patients can access their personal health information through our platform when requested.</p>
                </div>

                <div className="security-card">
                  <h3>Third-Party Security</h3>
                  <p>While we maintain confidentiality, we are not responsible for breaches outside our control.</p>
                </div>
              </div>

              <div className="security-notice">
                <h4>Important Security Note</h4>
                <p>
                  While encryption technology enhances security, no system is entirely invulnerable. We cannot assure the absolute
                  safety of our databases or that the information you provide won't be intercepted during transmission.
                  Any data you send to the Company is at your own risk. To protect your information, we strongly advise against sharing your password with anyone.
                </p>
              </div>
            </div>
          </section>

          {/* Section 6: Data Retention */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">6</div>
              <h2>Data Retention</h2>
            </div>
            <div className="section-content">
              <p>
                We retain your personal information only as long as necessary to provide our Services,
                comply with legal obligations, or resolve disputes. Specifically:
              </p>

              <div className="retention-grid">
                <div className="retention-card">
                  <h3>Account Information</h3>
                  <p>Retained for as long as your account remains active.</p>
                </div>

                <div className="retention-card">
                  <h3>Health and Emergency Data</h3>
                  <p>Retained for 7 years to comply with medical record-keeping requirements.</p>
                </div>

                <div className="retention-card">
                  <h3>Location Data</h3>
                  <p>Precise location data retained for 12 months, then anonymized.</p>
                </div>

                <div className="retention-card">
                  <h3>Ambulance Usage Data</h3>
                  <p>Retained for 24 months from the date of each emergency service use.</p>
                </div>

                <div className="retention-card">
                  <h3>Hospital Preference Data</h3>
                  <p>Retained for account duration + 12 months after closure.</p>
                </div>

                <div className="retention-card">
                  <h3>Usage Data</h3>
                  <p>Non-personal, aggregated usage data may be retained indefinitely.</p>
                </div>
              </div>

              <div className="retention-note">
                <p>
                  After the retention period, your data is either deleted or anonymized. Please note that hospitals
                  and ambulance services may have their own data retention policies for the information we share with them during emergencies.
                </p>
              </div>
            </div>
          </section>

          {/* Section 7: Business Transfer */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">7</div>
              <h2>Business Transfer</h2>
            </div>
            <div className="section-content">
              <p>
                In the event of a merger, acquisition, or sale of all or a portion of our assets, your information
                may be transferred as part of that transaction. We will notify you via email and/or a prominent notice
                on our website of any change in ownership or uses of your personal information, as well as any choices
                you may have regarding your personal information.
              </p>
            </div>
          </section>

          {/* Section 8: Information Collected by Drivers */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">8</div>
              <h2>Information Collected by Drivers</h2>
            </div>
            <div className="section-content">
              <p>
                This Privacy Policy does not cover any information about you that is collected by ambulance staff,
                paramedics, or hospital personnel during your emergency care, unless such information was provided
                by us through our Services. These parties may have their own privacy policies governing the use of
                information they collect directly from you.
              </p>
              <p>
                However, any information collected by these parties that is then transmitted back to Kode Blue
                (such as treatment summaries or transport details) becomes subject to this Privacy Policy once we receive it.
                We strive to ensure that all parties in our network handle your information with the utmost care and in
                compliance with applicable healthcare privacy laws.
              </p>
            </div>
          </section>

          {/* Section 9: Administrative and Legal Reasons */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">9</div>
              <h2>Administrative and Legal Reasons</h2>
            </div>
            <div className="section-content">
              <p>
                We work in conjunction with government authorities, law enforcement agencies, and private entities
                to ensure compliance with legal obligations. Consequently, we may access, utilize, retain, share,
                and disclose your information (including Protected Information, IP addresses, Device Information,
                and geo-location data) if we believe doing so is required or appropriate to:
              </p>

              <div className="legal-grid">
                <div className="legal-card">
                  <h4>Legal Compliance</h4>
                  <p>Comply with applicable laws and regulations including Information Technology Act, 2000, Motor Vehicles Act, 1988, and state healthcare laws.</p>
                </div>

                <div className="legal-card">
                  <h4>Legal Requests</h4>
                  <p>Respond to legal requests, court orders, or government inquiries.</p>
                </div>

                <div className="legal-card">
                  <h4>Safety Protection</h4>
                  <p>Protect the rights, property, or safety of Kode Blue Technologies, our users, or others.</p>
                </div>

                <div className="legal-card">
                  <h4>Fraud Prevention</h4>
                  <p>Detect, prevent, or address fraud, security threats, or technical issues.</p>
                </div>

                <div className="legal-card">
                  <h4>Public Safety</h4>
                  <p>Facilitate public safety measures as required by law enforcement or government agencies.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 10: Minor's & Children's Privacy */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">10</div>
              <h2>Minor's & Children's Privacy</h2>
            </div>
            <div className="section-content">
              <p>
                At Kode Blue Technologies, we are committed to protecting the privacy of children and minors.
                We recognize that minors may, in certain situations, require access to our emergency services.
                We do not knowingly collect personal information from children under 18 without parental consent.
                In cases where a minor accesses our services, we may collect and process their information solely
                for the purpose of providing necessary emergency assistance.
              </p>
              <p>
                In emergency cases involving minors, we collect and process only the information necessary to provide
                immediate medical assistance. We comply with all applicable Indian laws regarding the collection and
                use of children's data in emergency medical situations.
              </p>

              <div className="children-info">
                <h4>Parental Controls</h4>
                <p>
                  Parents or guardians can review, modify, or request deletion of their child's personal information
                  by contacting us at info@kodeblue.in. If we become aware that we have inadvertently collected personal
                  data from a child without proper consent, we will take reasonable steps to delete such information from our records.
                </p>
              </div>
            </div>
          </section>

          {/* Section 11: Updating Information & Account Cancellation */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">11</div>
              <h2>Updating Information & Account Cancellation</h2>
            </div>
            <div className="section-content">
              <p>
                You can update, correct, or delete your account information through your account settings or by
                contacting us at info@kodeblue.in. For access to your medical history or ambulance usage data,
                please submit a written request to info@kodeblue.in.
              </p>

              <div className="cancellation-info">
                <h4>Account Cancellation Process</h4>
                <p>To cancel your account, please contact us at info@kodeblue.in. Upon account cancellation:</p>

                <div className="cancellation-grid">
                  <div className="cancellation-item">
                    <div className="cancellation-icon">📁</div>
                    <div>
                      <h5>Data Retention Period</h5>
                      <p>We retain your data for 60 days in case you decide to reactivate your account.</p>
                    </div>
                  </div>

                  <div className="cancellation-item">
                    <div className="cancellation-icon">🗑️</div>
                    <div>
                      <h5>Data Deletion</h5>
                      <p>After 60 days, we delete or anonymize your personal information, except where legally required.</p>
                    </div>
                  </div>

                  <div className="cancellation-item">
                    <div className="cancellation-icon">📊</div>
                    <div>
                      <h5>Analytical Data</h5>
                      <p>Anonymized or aggregated data may be retained for analytical purposes.</p>
                    </div>
                  </div>

                  <div className="cancellation-item">
                    <div className="cancellation-icon">🏥</div>
                    <div>
                      <h5>Medical Records</h5>
                      <p>Medical data shared with hospitals may be subject to their retention policies.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 12: Your Rights */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">12</div>
              <h2>Your Rights</h2>
            </div>
            <div className="section-content">
              <p>
                In accordance with Indian data protection laws and regulations, you have the following rights:
              </p>

              <div className="rights-grid">
                <div className="right-card">
                  <h4>Right to Access</h4>
                  <p>Request a copy of the personal information we hold about you.</p>
                </div>

                <div className="right-card">
                  <h4>Right to Rectification</h4>
                  <p>Ask us to correct any inaccurate data we hold about you.</p>
                </div>

                <div className="right-card">
                  <h4>Right to Erasure</h4>
                  <p>Request deletion of your personal data in certain circumstances.</p>
                </div>

                <div className="right-card">
                  <h4>Right to Restrict Processing</h4>
                  <p>Ask us to restrict processing of your data in specific scenarios.</p>
                </div>

                <div className="right-card">
                  <h4>Right to Data Portability</h4>
                  <p>Request your data in machine-readable format for transfer.</p>
                </div>

                <div className="right-card">
                  <h4>Right to Object</h4>
                  <p>Object to our processing of your data in certain circumstances.</p>
                </div>

                <div className="right-card">
                  <h4>Review Usage History</h4>
                  <p>Review ambulance usage history and hospital preference data.</p>
                </div>

                <div className="right-card">
                  <h4>Modify Preferences</h4>
                  <p>Request modification or deletion of hospital preference data.</p>
                </div>

                <div className="right-card">
                  <h4>Opt Out</h4>
                  <p>Opt out of certain data collection, though this may impact service optimization.</p>
                </div>
              </div>

              <div className="rights-notice">
                <p>
                  To exercise these rights, please contact our Grievance Officer at info@kodeblue.in.
                  We will respond to your request within 30 days.
                </p>
              </div>
            </div>
          </section>

          {/* Section 13: Grievance Officer */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">13</div>
              <h2>Grievance Officer</h2>
            </div>
            <div className="section-content">
              <p>
                In accordance with the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021,
                we have appointed a Grievance Officer to address any concerns or complaints regarding this Privacy Policy or the
                handling of your personal information.
              </p>

              <div className="grievance-card">
                <h3>Grievance Officer Details</h3>
                <div className="grievance-details">
                  <div className="detail-item">
                    <strong>Name:</strong>
                    <span>KBT Support Manager</span>
                  </div>
                  <div className="detail-item">
                    <strong>Email:</strong>
                    <span>info@kodeblue.in</span>
                  </div>
                  <div className="detail-item">
                    <strong>Address:</strong>
                    <span>H.No: 5-11-1365, Hanuman Nagar, Hanamkonda, Warangal Urban, Telangana, India. 506009</span>
                  </div>
                </div>
                <div className="response-time">
                  <p>We will acknowledge receipt of your complaint within 24 hours and strive to resolve it within 15 days.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 14: Changes to This Privacy Policy */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">14</div>
              <h2>Changes to This Privacy Policy</h2>
            </div>
            <div className="section-content">
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with
                an updated effective date. For significant changes, we will notify you via email or through a prominent
                notice on our app or website. We encourage you to review this Privacy Policy periodically for any changes.
                Your continued use of our Services after such modifications will constitute your acknowledgment of the
                modified Privacy Policy and your agreement to abide and be bound by it.
              </p>
            </div>
          </section>

          {/* Section 15: Contact Us */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">15</div>
              <h2>Contact Us</h2>
            </div>
            <div className="section-content">
              <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>

              <div className="contact-card">
                <h3>Kode Blue Technologies</h3>
                <div className="contact-details">
                  <div className="contact-item">
                    <strong>Address:</strong>
                    <span>H.No: 5-11-1365, Hanuman Nagar, Hanamkonda, Warangal Urban, Telangana, India. 506009</span>
                  </div>
                  <div className="contact-item">
                    <strong>Email:</strong>
                    <span>info@kodeblue.in</span>
                  </div>
                  <div className="contact-item">
                    <strong>Phone:</strong>
                    <span>+91-8919214950</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Appendix */}
          <section className="policy-section appendix">
            <div className="section-header">
              <div className="section-number">A</div>
              <h2>Appendix: Definitions</h2>
            </div>
            <div className="section-content">
              <div className="definitions-grid">
                <div className="definition-card">
                  <h4>"Personal Information"</h4>
                  <p>Data that identifies you as an individual.</p>
                </div>

                <div className="definition-card">
                  <h4>"Health Information"</h4>
                  <p>Medical data specific to your health status.</p>
                </div>

                <div className="definition-card">
                  <h4>"Emergency Response Services"</h4>
                  <p>Our core service of connecting users with ambulances and hospitals in medical emergencies.</p>
                </div>

                <div className="definition-card">
                  <h4>"Hospital Network"</h4>
                  <p>The group of hospitals partnered with Kode Blue to provide emergency medical care.</p>
                </div>

                <div className="definition-card">
                  <h4>"Ambulance Service Providers"</h4>
                  <p>Third-party ambulance operators integrated into our platform.</p>
                </div>

                <div className="definition-card">
                  <h4>"Medical Data"</h4>
                  <p>Any information related to a user's health, medical condition, or treatment.</p>
                </div>

                <div className="definition-card">
                  <h4>"Services"</h4>
                  <p>Various offerings including Emergency Response Services, Data Management, Telemedicine Solutions, and User Support.</p>
                </div>

                <div className="definition-card">
                  <h4>"Device"</h4>
                  <p>Computer, mobile phone, or other device used to access the Services.</p>
                </div>

                <div className="definition-card">
                  <h4>"Mobile Application"</h4>
                  <p>Kode Blue application provided by us on the Device to access the Services.</p>
                </div>

                <div className="definition-card">
                  <h4>"Ambulance Usage Data"</h4>
                  <p>Information collected about your use of emergency ambulance services through our platform.</p>
                </div>

                <div className="definition-card">
                  <h4>"Hospital Preference Data"</h4>
                  <p>Information about your preferred hospitals and specific requirements for hospital care.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;